import { apiSlice } from '../../app/api/apiSlice'

export const distributorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createDistributor: builder.mutation ({
      query: (data) => ({
        url: `v1/distributor/register`,
        method: 'POST',
        body: data
      })
    })
  }),
})


export const {
  useCreateDistributorMutation
} = distributorApi
